import type { GaugeComponentSpec } from "../Processing/types";
import type { DuplicationHandler } from "../widgetContract";

export const gaugeDuplicate: DuplicationHandler<GaugeComponentSpec> = (spec) => {
  spec.queryId = crypto.randomUUID();
  if (spec.scaleQueryId) spec.scaleQueryId = crypto.randomUUID();
};
